import { render, staticRenderFns } from "./CXFirstAidSettings.vue?vue&type=template&id=e436260c&scoped=true&"
import script from "./CXFirstAidSettings.vue?vue&type=script&lang=js&"
export * from "./CXFirstAidSettings.vue?vue&type=script&lang=js&"
import style0 from "./CXFirstAidSettings.vue?vue&type=style&index=0&id=e436260c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e436260c",
  null
  
)

export default component.exports